export default __webpack_public_path__ + "static/gamerize-4-9f0913d5ca3af8be94a392bed0d39650.webp";